<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['elements']
    }
  },
  methods: {
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              nullable: false,
              required: true,
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'elements'],
              items: this.form.elements.map((item, i) => ({
                headerLabel: `Element nr ${i + 1}`,
                fields: [
                  new fields.Image({
                    label: 'Ikona',
                    modelPath: [this, 'form', 'elements', i, 'icon'],
                    required: true
                  }),
                  new fields.WYSIWYG({
                    label: 'Tekst',
                    modelPath: [this, 'form', 'elements', i, 'text'],
                    required: true
                  }),
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
